export const init = () => {
  /* SHOPPING TOOL - COLORAMA */

  const fwk = CUBE.Analytics;

  /**
   * COLORAMA on PAGELIST (Spotlightlist + Productlist)
   *
   * 	- If colorama changes : we add the 'model id' in the listColorama
   *
   */
  if (['list', 'internal_search'].includes(tc_vars.env_template)) {
    cube.event.on('product-item-swipe', payload => {
      // Get referenceId (model id) from index element
      if (payload && payload.index)
        fwk.colorama.add(payload.index.dataset.referenceId, 'pagelist');
    });
  }

  /**
   * COLORAMA on PRODUCT PAGE
   *
   * 	- If we land on product page with a previous colorama : we save it in the listColorama for the default 'model id'
   * 	- If colorama changes : we add the information (product or conversion) and the model id to the listColorama
   * 	- After each change : we update and persist the current state of the ST Colorama
   *
   */
  if (tc_vars.env_template === 'product') {
    // If we land here with a previous colorama (e.g. pagelist), we persist it for the default product
    const stPage = fwk.shoppingtool.get();
    if (stPage.stc)
      fwk.colorama.add(
        tc_vars.product_id_model,
        stPage.stc.replace('colorama-', '')
      );

    const coloramaEvent = fwk.utils.getEvent('colorama-conversion');
    if (coloramaEvent) {
      coloramaEvent.postAction($element => {
        const $allModels = $('.thumbs-product-list .model-selection');

        const index = $allModels.index($element);
        const modelId = $element.data('model-id');

        // // Add COLORAMMA to list
        if (index !== 0) {
          // Index == 0 > Default product (previous colorama, if any)
          if (fwk.utils.productpage.isConversionOpen())
            fwk.colorama.add(modelId, 'conversion');
          else {
            fwk.colorama.add(modelId, 'product');
          }
        }

        // Update & persist ST Colorama
        const st = fwk.shoppingtool.getActual();
        fwk.shoppingtool.set(st.st, st.std, fwk.colorama.getDetail(modelId));
        fwk.shoppingtool.persist();
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-colorama.js